import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const MilkYield = () => {
  const milk_yield = useInputStore(state => state.milk_yield)
  const setValue = useInputStore((state) => state.set_value)

  // validation
  const isValidNumber = useCallback(() => {
    const number = Number(milk_yield)

    // is it a valid number
    if (isNaN(number)) return false
    
    // is it a positive number
    return number >= 0
  }, [milk_yield])

  useStepValidator(INPUT_STEP_NAMES.numbers, 'milk_yield', () => isValidNumber(milk_yield))
  
  return (
    <Tooltip title='Kgs per head per year'>
    <TextField
      size='small'
      type='number' 
      label='Milk Yield'
      value={milk_yield}
      onChange={event => setValue({'milk_yield': parseFloat(event.target.value)})}
      error={!isValidNumber()}
      helperText={!isValidNumber() ? 'Please enter a valid number. This cannot be less than 0.' : ''}
    />
    </Tooltip>
  )
}
